import {Injectable, signal} from '@angular/core';

export type SnackbarType = 'success-snack' | 'danger-snack';

export interface Snack {
	id: number;
	message: string;
	type: SnackbarType;
}

/** How long a message stays: the host closes it at the end of its countdown. */
export const SNACK_DURATION_MS = 3000;
/** Beyond, the oldest message makes room. */
const MAX_SNACKS = 3;

/**
 * The messages of the app's single snackbar host (`<app-snackbar>`, in the root component). Each fades out by itself
 * at the end of its countdown, or at once on its cross.
 */
@Injectable({providedIn: 'root'})
export class SnackbarService {
	private nextId = 0;
	private readonly state = signal<Snack[]>([]);
	/** On screen, oldest first. */
	readonly snacks = this.state.asReadonly();

	/** A repeat starts over: the same message on screen gives way to a new one, which enters and counts down again. */
	show(message: string, type: SnackbarType = 'success-snack'): void {
		this.state.update(snacks => [
			...snacks.filter(snack => snack.message !== message || snack.type !== type),
			{id: this.nextId++, message, type},
		].slice(-MAX_SNACKS));
	}

	close(id: number): void {
		this.state.update(snacks => snacks.filter(snack => snack.id !== id));
	}
}
